// Ch78 · the (i) hover.
//
// Grant (2026-09-08): "a lot of unnecessary text — ensure the final version is
// just usable — add (i) info hover popups if needed."
//
// So no card on the Leads page carries a paragraph of subheader prose. Each
// one carries this: a 16px circled "i" beside the title whose tooltip says
// what the widget tells you and where its numbers come from. The explanation
// is one hover away instead of permanently in the way.

import React from "react";
import { Box, Tooltip } from "@mui/material";

export interface InfoDotProps {
  /** What this widget tells you, and what its numbers are counted from. */
  text: string;
  testId?: string;
}

export default function InfoDot({ text, testId }: InfoDotProps) {
  return (
    <Tooltip title={text} arrow enterTouchDelay={0} describeChild>
      <Box
        component="span"
        role="img"
        aria-label={text}
        data-testid={testId}
        sx={{
          display: "inline-grid",
          placeItems: "center",
          width: 16,
          height: 16,
          flex: "none",
          borderRadius: "50%",
          border: "1px solid",
          borderColor: "divider",
          color: "text.secondary",
          fontSize: 10,
          fontWeight: 700,
          cursor: "help",
          "&:hover": { borderColor: "primary.main", color: "primary.main" },
        }}
      >
        i
      </Box>
    </Tooltip>
  );
}
